import { render, staticRenderFns } from "./RadioGrade.vue?vue&type=template&id=582d331c&scoped=true&"
import script from "./RadioGrade.vue?vue&type=script&lang=js&"
export * from "./RadioGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d331c",
  null
  
)

export default component.exports